import React from 'react';
import { Grid, Col } from 'mrf/view/Grid';
import Tooltip from './Tooltip';
import { CsvIcon, PrinterIcon } from 'styles/components/Icons';
import store from 'mrf/redux/store';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import FileSaver from 'file-saver';
import usePrintMode from 'mrf/utils/usePrintMode';
import { useDispatch } from 'react-redux';
import { setPrintValueAction } from 'mrf/redux/actions/print';
import { renderTableCell } from './FetcherObjectTable';
import T from 'mrf/utils/T';
import If from 'mrf/utils/If';

const cleanUpForCsv = obj => {
    if (typeof obj == "string" ) {
        return obj.replace ? obj.replace('"', '\\"') : obj;
    } else if (!isNaN(obj)) {
        return obj;
    } else {
        return ""
    }
}

export default function TableFooter({ fields, byId, list, csvTitle, csvUser, csvCallback, showPrintButton = true }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const printMode = usePrintMode();

    const handlePrintMode = () => {
        dispatch(setPrintValueAction(true));
    }

    const exportCsvCallback = () => {
        const { resources } = store.getState();
        const csvLines = [];

        const headerLine = fields
            .map(f => f.name)
            .map(cleanUpForCsv);

        csvLines.push(`"${headerLine.join('","')}"`);

        for (let i=0; i<list.length; ++i) {
            const obj = byId[list[i]];

            const csvLine = fields
                .map(field => renderTableCell({
                    t,
                    resources,
                    idx: i,
                    obj,
                    field,
                }))
                .map(cleanUpForCsv);

            csvLines.push(`"${csvLine.join('","')}"`);
        }

        const blob = new Blob([ csvLines.join('\n') ], {type: "text/plain;charset=utf-8"});
        const currentTimestamp = moment(new Date()).format("YYYYMMDDhhmm");
        FileSaver.saveAs(blob, `${csvTitle}_${csvUser}_${currentTimestamp}.csv`);

    }

    return (
        <div className="flex w-full pt-4 -mt-4">
            <Grid
                justify='between'
                className='w-full px-4 py-1 border-t-2 rounded-b-lg shadow-md bg-paper text-color-light'
            >
                <Col size={6} justify='start'>
                    <span className='mr-2'>
                        <T>Number of Records</T>: { list?.length }
                    </span>
                </Col>
                <Col size={6} justify='end'>
                    <If condition={!printMode}>
                        <If condition={showPrintButton}>
                            <Tooltip content='Print'>
                                <PrinterIcon size={30} onClick={handlePrintMode} id='printMode' />
                            </Tooltip>
                        </If>
                        <Tooltip content='Export CSV'>
                            <CsvIcon size={30} onClick={csvCallback ?? exportCsvCallback} id='exportCsv' />
                        </Tooltip>
                    </If>
                </Col>
            </Grid>
        </div>
    );
}
